import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToAnchor = () => {
    const { pathname, hash, key } = useLocation();
    const lastHash = useRef('');

    useEffect(() => {
        if (hash) {
            lastHash.current = hash;
            const id = hash.replace('#', '');

            // Allow time for layout to shift/render
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    const headerOffset = 100; // Navbar height + buffer
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.scrollY - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 150);
        } else {
            // Only scroll to top if we weren't just at a hash (prevent fighting with browser back button sometimes, though simplified logic here is fine for now)
            // Or typically, just scroll to top on route change without hash.
            window.scrollTo(0, 0);
        }
    }, [pathname, hash, key]);

    return null;
};

export default ScrollToAnchor;
